export async function shareLeaderboard(tournament, rows) {
  const top = (rows || [])
    .slice(0, 12)
    .map((r) => `${r.rank}. ${r.display_name} — ${r.total_points}pts`)
    .join("\n");
  const url = window.location.href;
  const text = `🃏 ${tournament.name} — Live Standings\n\n${top || "No results yet"}\n\nFull leaderboard:`;

  if (navigator.share) {
    try {
      await navigator.share({ title: tournament.name, text, url });
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled";
    }
  }
  // Fallback: WhatsApp (works on desktop + mobile), one tap on phones
  window.open(`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`, "_blank");
  return "whatsapp";
}

export function shareViaSms(tournament, rows) {
  const top = (rows || [])
    .slice(0, 12)
    .map((r) => `${r.rank}. ${r.display_name} ${r.total_points}pts`)
    .join("\n");
  const url = window.location.href;
  const body = `${tournament.name} — Standings\n${top}\n${url}`;
  window.open(`sms:?&body=${encodeURIComponent(body)}`, "_blank");
}

export async function copyLeaderboard(tournament, rows) {
  const top = (rows || [])
    .slice(0, 12)
    .map((r) => `${r.rank}. ${r.display_name} — ${r.total_points}pts`)
    .join("\n");
  const url = window.location.href;
  const text = `${tournament.name} — Live Standings\n\n${top}\n\n${url}`;
  await navigator.clipboard.writeText(text);
  return true;
}
